var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"mr-2",attrs:{"id":"import-user-dropdown","text":_vm.$t('TABLES.PROJECT_USER_NAVS.IMPORT'),"size":"sm","variant":"primary","right":""}},[_c('UserImportLive',{attrs:{"segmentationBreakdown":_vm.segmentationBreakdown}}),_c('UserImportFile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }